import * as React from "react";
import {
    PlasmicWaitlistForm,
    DefaultWaitlistFormProps
} from "./plasmic/main/PlasmicWaitlistForm";
import {useCallback, useState} from "react";
import {createWaitlistEntry} from "../api/fetch-requests";

export interface WaitlistFormProps extends DefaultWaitlistFormProps {
}

type formState = "success" | undefined;

function WaitListForm({...rest}: WaitlistFormProps) {
    const [state, setState] = useState<formState>(undefined);
    const submit = useCallback((e: any) => {
        e.preventDefault();
        createWaitlistEntry({
            name: e.target[0].value,
            profession: e.target[1].value,
            email: e.target[2].value
        });
        setState("success");
    }, []);


    return <PlasmicWaitlistForm
        root={{
            onClick: (e) => {
                e.stopPropagation();
            }
        }}
        state={state}
        form={{
            onSubmit: submit
        }}
        {...rest} />;
}

export default WaitListForm;
